import { useEffect, useState } from "react";
import { api } from "../../api/api";
import { expectArray } from "rant-utils";
import { entity } from "../../types";


type ArrItemType = {
	entity: string,
} | any;

// expect arr items to contain a .entity prop which is a string id of an entity
export function useEntityLookup(
	arr: ArrItemType[],
	getID?: (item: any) => string,
) {

	const [data, setData] = useState<{
		map: { [key: string]: entity },
		items: entity[],
	} | null>(null);

	useEffect(() => {
		if (!arr) return;

		const ids = [];
		for(let item of arr) {
			let id;

			if (getID) {
				id = getID(item);
			} else {
				id = item.entity;
			}

			if (!id) continue;

			if (ids.indexOf(id) < 0) ids.push(id);	
		}

		if (ids.length <= 0) return;

		api.entity_get_specific({
			ids,
		}).then((items) => {
			const arr = expectArray(items);
			const map = {} as any;
			for(let i of arr) {
				map[i.id] = i;
			}

			setData({
				items: arr,
				map,
			});

		}).catch(() => {

		});

	}, [arr]);

	function get(id: string): entity | undefined {
		if (!data || !data.map) return;

		const e = data.map[id];
		if (!e) return;

		return e;
	}

	function getName(id: string) {
		const e = get(id);
		return e ? e.title : undefined;
	}

	return {
		...data,
		get,
		getName,
	};
	
}